module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gs-a96857cd4e8cd95734f9af34ce767b6a.svg";